import { useIsKeyboardNavigationState } from '@wkda/styleguide';
import { useEffect } from 'react';
import { useFormMachine } from './CarleadCreationForm';
export function SyncStateMachineKeyboardNavigation() {
  const machineFormService = useFormMachine();
  const isTabbing = useIsKeyboardNavigationState();
  useEffect(() => {
    machineFormService.send({
      type: 'SET_KEYBOARD_NAVIGATION',
      isKeyboardNavigation: isTabbing
    });
  }, [isTabbing, machineFormService]);
  return null;
}